import React from 'react';
import ToggleRadioButton from '../ToggleRadioButton/ToggleRadioButton';
import './FastDoctorReview.css';

export interface FastDoctorReviewProps {
  enabled: boolean;
  onToggleChange: (enabled: boolean) => void;
  title: string;
  description: string;
  label?: string;
  toggleId?: string;
}

const FastDoctorReview: React.FC<FastDoctorReviewProps> = ({
  enabled,
  onToggleChange,
  title,
  description,
  label,
  toggleId = 'fast-doctor-review-toggle',
}) => {
  return (
    <div
      id='fast-doctor-review-container'
      className="w-full fast-doctor-review-card"
      data-enabled={enabled ? 'true' : 'false'}
    >
      <div className="flex flex-col gap-1 flex-1">
        <div className="flex items-center gap-2">
          <span className="text-sm font-semibold text-[#037D73]">
            {title}
          </span>
          {label != null && label !== '' && (
            <span className="fast-doctor-review-neu-badge">
              {label}
            </span>
          )}
        </div>
        <span className="fast-doctor-review-description">
          {description}
        </span>
      </div>
      <div className="flex items-center ml-8">
        <div className="relative fast-doctor-review-toggle-wrap">
          <ToggleRadioButton
            id={toggleId}
            isToggleEnabled={enabled}
            updateToggle={onToggleChange}
          />
          <div className="fast-doctor-review-toggle-thumb" aria-hidden>
            <svg className="w-[9px] h-[13px]" viewBox="0 0 9 13" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M8.98557 5.94348C8.96476 5.8438 8.92159 5.75105 8.8598 5.67326C8.79802 5.59547 8.71947 5.53497 8.63096 5.497L6.12765 4.42431L6.64563 0.724135C6.66464 0.591265 6.64341 0.455363 6.58506 0.336365C6.5267 0.217366 6.43429 0.121533 6.32138 0.0629229C6.20847 0.00431247 6.081 -0.0139909 5.95766 0.0106977C5.83433 0.0353862 5.72163 0.101767 5.63609 0.200104L0.15795 6.48847C0.0928327 6.56318 0.0456973 6.65378 0.0206261 6.75241C-0.00444513 6.85104 -0.00669622 6.95473 0.0140677 7.0545C0.0348316 7.15427 0.0779845 7.24711 0.139789 7.32499C0.201594 7.40286 0.280186 7.46342 0.36876 7.50142L2.87207 8.57411L2.3541 12.2759C2.33508 12.4087 2.35631 12.5446 2.41466 12.6636C2.47302 12.7826 2.56543 12.8785 2.67834 12.9371C2.79126 12.9957 2.91873 13.014 3.04206 12.9893C3.16539 12.9646 3.2781 12.8982 3.36364 12.7999L8.84177 6.51153C8.90718 6.43659 8.95447 6.34565 8.97954 6.24664C9.0046 6.14763 9.00667 6.04355 8.98557 5.94348ZM3.79553 10.4591L4.10221 8.27018C4.12181 8.13008 4.09668 7.987 4.0309 7.86412C3.96511 7.74124 3.86253 7.64575 3.73977 7.59313L1.60134 6.6766L5.20419 2.54095L4.89752 4.72982C4.87792 4.86992 4.90305 5.013 4.96883 5.13588C5.03461 5.25877 5.13719 5.35425 5.25995 5.40687L7.39838 6.3234L3.79553 10.4591Z" fill="#727272" />
            </svg>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FastDoctorReview;
